(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[46661,40659,81066,75847,44709,40852,81243,74453,44954,40617],{

/***/ 87305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var UI_components_Svg__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6778);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95121);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3__);






var AccordionItem = function(param) {
    var handleClick = param.handleClick, title = param.title, isOpen = param.isOpen, buttonClassName = param.buttonClassName, isOpenClassName = param.isOpenClassName, isCloseClassName = param.isCloseClassName, className = param.className, children = param.children;
    var ref;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var _obj;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["accordion-item"]), className, (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, isCloseClassName, !isOpen), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, isOpenClassName, isOpen), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().isClose), !isOpen), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().isOpen), isOpen), _obj)),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                type: "button",
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["accordion-button"]), buttonClassName),
                onClick: handleClick,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UI_components_Svg__WEBPACK_IMPORTED_MODULE_5__["default"], {
                        type: "plus",
                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().icon), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().isOpen), isOpen))
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["accordion-collapse"]),
                style: isOpen ? {
                    height: ref1 === null || ref1 === void 0 ? void 0 : (ref = ref1.current) === null || ref === void 0 ? void 0 : ref.scrollHeight
                } : {
                    height: "0px"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    ref: ref1,
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["accordion-body"]),
                    children: children
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AccordionItem);


/***/ }),

/***/ 88181:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ sections_CaseAccordion; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./UI/components/SectionTitle/index.jsx
var SectionTitle = __webpack_require__(15805);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/SwitchTransition.js
var SwitchTransition = __webpack_require__(45989);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/CSSTransition.js + 3 modules
var CSSTransition = __webpack_require__(76743);
// EXTERNAL MODULE: ./components/BlogCommon/Article/ContentfulParser/index.jsx
var ContentfulParser = __webpack_require__(92870);
// EXTERNAL MODULE: ./UI/components/AccordionItem/index.jsx
var AccordionItem = __webpack_require__(87305);
// EXTERNAL MODULE: ./UI/components/Svg/index.jsx
var Svg = __webpack_require__(6778);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
;// CONCATENATED MODULE: ./UI/sections/CaseAccordion/utils/useSectionProps.js


/* harmony default export */ function useSectionProps(param) {
    var section = param.section, data = param.data, type = param.type;
    var ref = (0,react.useState)(0), activeAccordion = ref[0], setAccordion = ref[1];
    var ref1 = (0,react.useState)(0), activeCard = ref1[0], setCard = ref1[1];
    var ref2 = (0,helper/* getDocumentFields */.OA)(section, [
        "title",
        "description",
        "contentModules",
        "view", 
    ]), title = ref2.title, description = ref2.description, contentModules = ref2.contentModules, view = ref2.view;
    var handleAccordionClick = (0,react.useCallback)(function(id) {
        setAccordion(id);
        setCard(0);
    }, []);
    var accordionList = (0,react.useMemo)(function() {
        return (contentModules || []).map(function(item, id) {
            return (0,helper/* getDocumentFields */.OA)(item, [
                "title",
                "text", 
            ]);
        });
    }, [
        contentModules
    ]);
    var activeImage = (0,react.useMemo)(function() {
        var images = (0,helper/* getDocumentFields */.OA)(contentModules[activeAccordion], [
            "images"
        ]).images;
        return images[0];
    }, [
        activeAccordion,
        contentModules
    ]);
    return {
        type: type,
        view: view,
        title: title,
        description: description,
        activeImage: activeImage,
        accordionList: accordionList,
        activeAccordion: activeAccordion,
        handleAccordionClick: handleAccordionClick
    };
};

// EXTERNAL MODULE: ./UI/sections/CaseAccordion/styles.module.scss
var styles_module = __webpack_require__(52184);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/sections/CaseAccordion/index.jsx










var Media = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 34190));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(34190)
            ];
        }
    }
});
var CaseAccordion = function(props) {
    var ref = useSectionProps(props), title = ref.title, description = ref.description, accordionList = ref.accordionList, activeAccordion = ref.activeAccordion, handleAccordionClick = ref.handleAccordionClick, activeImage = ref.activeImage, view = ref.view, type = ref.type;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: classnames_default()((styles_module_default())[view], (styles_module_default())[type], (styles_module_default()).section),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle["default"], {
                title: title,
                description: description,
                className: (styles_module_default()).sectionTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default()).contentWrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: (styles_module_default()).accordion,
                        children: (accordionList || []).map(function(item, id) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionItem/* default */.Z, {
                                isOpen: id === activeAccordion,
                                handleClick: function() {
                                    return handleAccordionClick(id);
                                },
                                title: item.title,
                                className: (styles_module_default()).accordionItem,
                                isCloseClassName: (styles_module_default()).isClose,
                                isOpenClassName: (styles_module_default()).isOpen,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentfulParser["default"], {
                                    document: item.text,
                                    linkIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg["default"], {
                                        type: "arrowNarrowUp"
                                    })
                                })
                            }, id);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SwitchTransition/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CSSTransition/* default */.Z, {
                            timeout: 300,
                            classNames: {
                                enter: (styles_module_default())["fade-enter"],
                                enterActive: (styles_module_default())["fade-enter-active"],
                                exit: (styles_module_default())["fade-exit"],
                                exitActive: (styles_module_default())["fade-exit-active"]
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (styles_module_default())["card-body"],
                                children: activeImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(Media, {
                                    asset: activeImage,
                                    className: (styles_module_default()).media
                                })
                            })
                        }, title)
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var sections_CaseAccordion = (CaseAccordion);


/***/ }),

/***/ 40659:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Common_LinkWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./utils/ga.js
var ga = __webpack_require__(48114);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
;// CONCATENATED MODULE: ./components/Common/LinkWrapper/helpers/index.js
var isAbsoluteUrl = function(path) {
    try {
        var _ = new URL(path);
        return true;
    } catch (e) {
        return false;
    }
};

// EXTERNAL MODULE: ./components/Common/LinkWrapper/styles.module.scss
var styles_module = __webpack_require__(81098);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./components/Common/LinkWrapper/index.jsx










var LinkWrapper = function(param) {
    var path = param.path, className = param.className, children = param.children, googleAnalyticProps = param.googleAnalyticProps, isSocialLink = param.isSocialLink, onClick = param.onClick;
    var isAbsoluteLink = (0,react.useMemo)(function() {
        return isAbsoluteUrl(path);
    }, [
        path
    ]);
    var isLocalLink = !isAbsoluteLink || path.includes(constants/* CUSTOM_DOMAIN */.zq);
    if (!path) {
        return children;
    }
    var target = !isLocalLink ? "_blank" : undefined;
    var rel = isSocialLink || isLocalLink ? undefined : "noopener noreferrer nofollow";
    var href = !isAbsoluteLink && path[0] !== "/" ? "/".concat(path) : path;
    var handleOnClick = function(e) {
        if (!isEmpty_default()(googleAnalyticProps)) {
            var category = googleAnalyticProps.category, action = googleAnalyticProps.action, label = googleAnalyticProps.label, data = googleAnalyticProps.data;
            ga/* default.trackEvent */.Z.trackEvent(category || data, action || data, label || data);
        }
        onClick(e);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: href,
        /* TODO: if you need to instantly open pages via links in the navigation,
      you can remove this code to enable link page generation and loading. However, performance will be degraded
      more: https://nextjs.org/docs/api-reference/next/link */ prefetch: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: classnames_default()((styles_module_default()).link, className),
            onClick: handleOnClick,
            target: target,
            rel: rel,
            children: children
        })
    });
};
LinkWrapper.defaultProps = {
    path: null,
    className: null,
    googleAnalyticProps: {},
    children: null,
    isSocialLink: false,
    onClick: function() {}
};
LinkWrapper.propTypes = {
    path: (prop_types_default()).string,
    className: (prop_types_default()).string,
    googleAnalyticProps: prop_types_default().instanceOf(Object),
    children: (prop_types_default()).node,
    isSocialLink: (prop_types_default()).bool,
    onClick: (prop_types_default()).func
};
/* harmony default export */ var Common_LinkWrapper = (LinkWrapper);


/***/ }),

/***/ 95121:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"accordion-item":"styles_accordion-item__B_m85","isClose":"styles_isClose__G5w5J","isOpen":"styles_isOpen__E6I_a","accordion-button":"styles_accordion-button__L2wmf","icon":"styles_icon__CKQ5A","accordion-body":"styles_accordion-body__6ClGP","accordion-collapse":"styles_accordion-collapse__zcZhR"};

/***/ }),

/***/ 52184:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"styles_section__gFuP5","sectionTitle":"styles_sectionTitle__Iadf6","contentWrapper":"styles_contentWrapper__FyNw7","accordion":"styles_accordion__DsyVG","card-body":"styles_card-body__NnyX9","media":"styles_media__TTEAA","computer-vision-for-aras":"styles_computer-vision-for-aras__Tnxue","accordionItem":"styles_accordionItem__cAdaU","isClose":"styles_isClose__uPADy"};

/***/ }),

/***/ 81098:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"link":"styles_link__MXUD5"};

/***/ })

}]);